export const consts = {
  userAgentName: 'User-Agent',
  mobApp: 'mob-app',
  enabled: true,
  otherFilters: 'event_1',
}
